__turbopack_context__.v({
  "overhead": "_8J6JxW_overhead",
  "overhead--black": "_8J6JxW_overhead--black",
  "overhead--green": "_8J6JxW_overhead--green",
  "overhead--main": "_8J6JxW_overhead--main",
  "overhead--pink": "_8J6JxW_overhead--pink",
  "overhead__close-btn": "_8J6JxW_overhead__close-btn",
  "text": "_8J6JxW_text",
});
